<template>
  <v-container fluid>
    <v-row class="ma-3" wrap>
      <!-- Descrição -->
      <v-col cols="12">
        <v-text-field
          v-model="formacao.descricao"
          ref="descricao"
          label="Descrição"
          placeholder="Digite a descrição da formação"
          dense
          outlined
          data-vv-as="descrição"
          persistent-hint
          :hint="errors.first('res_formacao.descricao')"
          :error="
            errors.collect('res_formacao.descricao').length ? true : false
          "
          v-validate="'required|min:3|max:150'"
          data-vv-scope="res_formacao"
          data-vv-validate-on="change"
          id="descricao"
          name="descricao"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "FormacaoForm",
  inject: ["$validator"],
  computed: {
    formacao: {
      get() {
        return this.$store.getters["resFormacoes/getFormacao"];
      },
      set(value) {
        this.$store.dispatch("resFormacoes/setFormacao", value);
      },
    },
  },
};
</script>

<style></style>
